import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarFooterService, CclMessageService, CclDrawerService } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { cloneDeep } from "lodash";
import { EventService } from "../../../../../modules/shared/services/event.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-mysession-page",
    templateUrl: "./mysession-page.view.html",
    styleUrls: []
})
export class MySessionPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    baseUrl: string;
    mysessionConfigObj: any;
    mysessionConfig: any = {};
    forms: any = [];
    catalogLayoutConfig: any = {};
    hoverOut: boolean = false;
    hover: boolean = false;
    headerLayout: string;
    fontstyle: any = {};
    myschedulefontstyle: any = {};
    constructor(
        public sharedService: SharedService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private localDataService: LocalDataService,
        private drawerService: CclDrawerService,
        private eventService: EventService
    ) {
        super(sharedService);
        this.localDataService.getJSON("my-session-ddf.json").subscribe((data) => {
            if (data != null) {
                this.ddfData = data;
            }

            if (this.sharedService.sessionCustomFields != null) {
                this.sharedService.sessionCustomFields.forEach((cf) => {
                    this.ddfData.push({
                        label: cf.name,
                        key: "{@ddf.customFieldMap." + cf.code + "@}",
                        type: "Session custom field"
                    });
                });
            }
            this.headerLayout = this.getFormattedDDFData("header");
        });
        this.baseUrl = "mysession";
        sharedService.sessionUrl = this.baseUrl;

        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveMysessionConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.sharedService.currentLayoutSection = "mysession";
        this.mysessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.MYSESSION];
        this.eventService.getFormsByUUID(this.sharedService.eventUUID, 150).subscribe((resp) => {
            this.forms = resp.body["formDTOList"];
        });

        if (this.mysessionConfigObj == null || this.mysessionConfigObj.id == null) {
            this.mysessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            this.mysessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.MYSESSION
            };
        } else {
            this.mysessionConfig = JSON.parse(this.mysessionConfigObj.config);
            this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.mysessionConfig);
        }

        if (!this.mysessionConfig.hasOwnProperty("my_schedule")) {
            this.mysessionConfig.my_schedule = cloneDeep(this.sharedService.sessionLayoutConfig['myschedule']);
        }

        if (!this.mysessionConfig.hasOwnProperty("isSessionEnabled")) {
            this.mysessionConfig.isSessionEnabled = true;
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.mysessionConfig);
        this.sharedService.changedData = this.mysessionConfig;

        this.fontstyle = {
            color: this.mysessionConfig.header.label_color,
            "font-style": this.mysessionConfig.header.fontStyle,
            "text-decoration": this.mysessionConfig.header.fontStyle,
            "font-weight":
                this.mysessionConfig.header.fontStyle != "bold" ? "normal" : this.mysessionConfig.header.fontStyle
        };
        this.myschedulefontstyle = {
            color: this.mysessionConfig.my_schedule.my_schedule_header.label_color,
            "font-style": this.mysessionConfig.my_schedule.my_schedule_header.fontStyle,
            "text-decoration": this.mysessionConfig.my_schedule.my_schedule_header.fontStyle,
            "font-weight":
                this.mysessionConfig.my_schedule.my_schedule_header.fontStyle != "bold" ? "normal" : this.mysessionConfig.my_schedule.my_schedule_header.fontStyle
        };
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = (this.sharedService.enableSessionWidgets ? "NEXT STEP: Define Data for Event Advisor section" : "NEXT STEP: Define Data for Highlighted section");
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-mysession";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-mysession";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveMysessionConfig(message) {
        if (message.text == "save-mysession" || message.text == "save-next-mysession") {
            this.mysessionConfigObj.config = JSON.stringify(this.mysessionConfig);
            this.catalogService.saveSetupConfig(this.mysessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.mysessionConfig);
                this.sharedService.changedData = this.mysessionConfig;

                this.mysessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.MYSESSION] = this.mysessionConfigObj;
                this._flashMessagesService.show("My Session config saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-mysession") {
                    this.sharedService.currentLayoutSection = (this.sharedService.enableSessionWidgets ? "sessionrecommendationwidget" : "highlighted");
                    this.sharedService.catalogNavigateHelper("admin", (this.sharedService.enableSessionWidgets ? "catalog/recommendations-widget/sessionrecommendationwidget" : "catalog/data/highlighted"));
                }
            });
        } else if (message.text == "apply-mysession-config") {
            this.mysessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            // For checking unsaved data
            this.sharedService.changedData = this.mysessionConfig;

            this.mysessionConfig.button.primary.background = this.mysessionConfig.header.background;
            this.mysessionConfig.button.primary.color = this.mysessionConfig.header.label_color;
            this.mysessionConfig.button.secondary.background = this.mysessionConfig.header.label_color;
            this.mysessionConfig.button.secondary.color = this.mysessionConfig.header.background;
            this.headerLayout = this.getFormattedDDFData("header");
            this.fontstyle = {
                color: this.mysessionConfig.header.label_color,
                "font-style": this.mysessionConfig.header.fontStyle,
                "text-decoration": this.mysessionConfig.header.fontStyle,
                "font-weight":
                    this.mysessionConfig.header.fontStyle != "bold" ? "normal" : this.mysessionConfig.header.fontStyle
            };

            this.fontstyle = {};
            setTimeout(() => {
                this.fontstyle = {
                    color: this.mysessionConfig.header.label_color,
                    "font-style": this.mysessionConfig.header.fontStyle,
                    "text-decoration": this.mysessionConfig.header.fontStyle,
                    "font-weight":
                        this.mysessionConfig.header.fontStyle != "bold"
                            ? "normal"
                            : this.mysessionConfig.header.fontStyle
                };
            }, 0);
            this.myschedulefontstyle = {
                color: this.mysessionConfig.my_schedule.my_schedule_header.label_color,
                "font-style": this.mysessionConfig.my_schedule.my_schedule_header.fontStyle,
                "text-decoration": this.mysessionConfig.my_schedule.my_schedule_header.fontStyle,
                "font-weight":
                    this.mysessionConfig.my_schedule.my_schedule_header.fontStyle != "bold" ? "normal" : this.mysessionConfig.my_schedule.my_schedule_header.fontStyle
            };

            this.myschedulefontstyle = {};
            setTimeout(() => {
                this.myschedulefontstyle = {
                    color: this.mysessionConfig.my_schedule.my_schedule_header.label_color,
                    "font-style": this.mysessionConfig.my_schedule.my_schedule_header.fontStyle,
                    "text-decoration": this.mysessionConfig.my_schedule.my_schedule_header.fontStyle,
                    "font-weight":
                        this.mysessionConfig.my_schedule.my_schedule_header.fontStyle != "bold"
                            ? "normal"
                            : this.mysessionConfig.my_schedule.my_schedule_header.fontStyle
                };
            }, 0);
            this.drawerService.hideDrawer();
        }
    }

    ddfData: Array<any> = [];

    getFormattedDDFData(expansionStyle) {
        let contentString = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[expansionStyle]
            .textConfig.template;
        if (contentString != null) {
            this.ddfData.forEach(function(value, key) {
                if (contentString.indexOf(value.key) > -1) {
                    contentString = contentString.replace(new RegExp(value.key, "g"), value.label);
                }
            });
            return contentString
                .replace(new RegExp('contenteditable="true"', "g"), "")
                .replace(new RegExp("contenteditable='true'", "g"), "");
        } else {
            return "";
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.mysessionConfig);
        this.sharedService.expansionStyle = expansionStyle;
        if (item == "header") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "My Sessions Header",
                navLinks: null,
                saveMessage: "apply-mysession-config"
            };
            url = "config-drawer/session/mysession-config";
        } else if (item == "drawer-control") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "My Sessions Drawer Control",
                navLinks: null,
                saveMessage: "apply-mysession-config"
            };
            url = "config-drawer/session/mysession-config";
        } else if (item == "tabs") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Tabs",
                navLinks: null,
                saveMessage: "apply-mysession-config"
            };
            url = "config-drawer/session/mysession-config";
        } else if (item == "html") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-mysession-config"
            };
            url = "config-drawer/session/html-config";
        } else if (item == "button") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Buttons",
                navLinks: null,
                saveMessage: "apply-mysession-config"
            };
            url = "config-drawer/session/mysession-config";
        } else if (item == "calendar-control") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Calendar Control",
                navLinks: null,
                saveMessage: "apply-mysession-config"
            };
            url = "config-drawer/session/calendar-config";
        } else if(item == 'myschedule-header') {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "My Schedule Header",
                navLinks: null,
                saveMessage: "apply-mysession-config"
            };
            url = "config-drawer/session/myschedule-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    changeForm(formId) {
        if (this.forms != null) {
            this.forms.forEach((form) => {
                if (form.id == formId) {
                    this.mysessionConfig.formId = form.id;
                    this.mysessionConfig.formDTO = form;
                }
            });
        }
    }

    toggleSchduleEnabled(e) {
        this.mysessionConfig.my_schedule.isScheduledEnabled = !this.mysessionConfig.my_schedule.isScheduledEnabled;
    }

    toggleSessionEnabled(ev) {
        this.mysessionConfig.isSessionEnabled = !this.mysessionConfig.isSessionEnabled;
    }
}
